import React from "react";
import IMG from "../assets/images/IMG.png";

export const Header = () => {
  return (
    <div 
      className=" z-30
        shadow-md
        flex
        items-center
        px-5
        md:px-14
        py-4
        fixed
        w-full
        top-0
        right-0
        bg-white
      ">
      <img
        className="
          h-10
          w-10
          sm:h-16
          sm:w-16
          shadow-md
          rounded-full
          mr-4
          object-cover
        "
        src={IMG}
        alt="mahditahavorgar"
      />
      <span className="line-through text-base sm:text-xl">Mahdi Tahavorgar.</span>
    </div>
  );
};
